module.exports = __webpack_public_path__ + "img/arrow_right.5980ca56.svg";